import { render, staticRenderFns } from "./new-order.vue?vue&type=template&id=234f676c"
import script from "./new-order.vue?vue&type=script&lang=js"
export * from "./new-order.vue?vue&type=script&lang=js"
import style0 from "./new-order.vue?vue&type=style&index=0&id=234f676c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports